/* Types */
import { AutocompleteService } from '@/types/mapServices'
import { SuggestionSettings } from '@/store/city/city.types'

/* Services */
import { makeDadataAutocompleteService } from '@/services/autocomplete/deliveryDadata'
import { makeGoogleAutocompleteService } from '@/services/autocomplete/deliveryGoogle'

let autocompleteService = null as null | AutocompleteService

// TODO: В будущем все будет заменено на api бэкенда
export const autocompleteServiceFactory = async (
  providerData: SuggestionSettings,
): Promise<AutocompleteService> => {
  switch (providerData.provider) {
    case 'google': {
      autocompleteService = await makeGoogleAutocompleteService(
        providerData.api_key,
      )
      break
    }
    case 'dadata':
    default: {
      autocompleteService = makeDadataAutocompleteService(providerData.api_key)
    }
  }
  return autocompleteService
}

export const getAutocompleteService = (
  providerData: SuggestionSettings,
): Promise<AutocompleteService> => {
  // @ts-ignore
  if (autocompleteService) return autocompleteService

  return autocompleteServiceFactory(providerData)
}
